<template>
  <div class="header">
    <div
      :class="[
        'head-item',
        item.highLightList.indexOf(currPath) != -1 ? 'click-color' : '',
      ]"
      v-for="(item, i) in headList"
      :key="i"
      @click="TabItem(item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "GHeader",
  data() {
    return {
      headList: [
       
      ],
      currPath: null,
    };
  },
  created() {
    this.currPath = this.$route.path;
    if(this.jx!=1){
        this.headList=[
             {
          name: "学习统计",
          path: "/home",
          highLightList: ["/home"],
        },
        {
          name: "社区服务统计",
          path: "/server",
          highLightList: ["/server"],
        },
        {
          name: "签到统计",
          path: "/sign",
          highLightList: ["/sign"],
        },
        ]
    }else{
         this.headList=[
             {
          name: "学习统计",
          path: "/home",
          highLightList: ["/home"],
        },
        {
          name: "公益活动统计",
          path: "/server",
          highLightList: ["/server"],
        },
        {
          name: "签到统计",
          path: "/sign",
          highLightList: ["/sign"],
        },  
        ]
    }
   
      // this.TabItem({
      //     name: "学习统计",
      //     path: "/home",
      //     highLightList: ["/home"],
      //   })
//     this.$router.push({
//     query:merge(this.$route.query,{'id':'630'})
// })
    // this.$route.query =  {areaId:this.$route.query.areaId,
    //    jx: this.jx
    //  }
    
      
    // this.$route.query.push({jx: this.jx})
    

     
  },
  props: ["areaId"],                        
  methods: {
    TabItem(item) {
      this.$router.push({
        path: item.path,
        query: { areaId: this.areaId,jx: this.jx },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  display: flex;
  height: 0.78rem;
  background-color: #fff;
  border-bottom: 1px solid rgba(152, 152, 152, 0.6);
  font-size: 0.28rem;
  color: #666666;

  .head-item {
    height: 100%;
    flex: 1;
    text-align: center;
    line-height: 0.78rem;
  }
  .click-color {
    font-weight: bold;
    color: #000;
    border-bottom: 2px solid #121212;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue